import type { User, UserType } from "../api/auth";

export const DEFAULT_ALLOWED_ARNS = ["195203", "309186", "321367"];

export const RESEARCH_ARNS = ["353115"];

/**
 * ARN segment for employee username prefix `ARN-{arn}.suffix`.
 * Supports distributor login (`195203`, `ARN-195203`) and employee (`ARN-195203.alias`).
 */
export function usernameWithoutPrefix(username: string): string {
  const withoutPrefix = String(username)
    .trim()
    .replace(/^ARN-?/i, "");
  return withoutPrefix;
}

export function distributorArnFromUsername(username: string): string {
  const withoutPrefix = String(username)
    .trim()
    .replace(/^ARN-?/i, "");
  const dot = withoutPrefix.indexOf(".");
  return dot === -1 ? withoutPrefix : withoutPrefix.slice(0, dot);
}

export function isFeatureEnabledForArn(
  arn: string,
  environment: string
): boolean {
  const normalizedEnvironment = environment.toLowerCase().trim();

  const isProdEnvironment =
    normalizedEnvironment === "prod" || normalizedEnvironment === "production";

  if (!isProdEnvironment) return true;

  return DEFAULT_ALLOWED_ARNS.some((allowedArn) => arn.includes(allowedArn));
}

export function isEmployeeUser(userType: UserType | null | undefined): boolean {
  return userType === "employee";
}

export function isEmployeeUserWithEmployeeRole(user: User): boolean {
  if (!user || user.user_type !== "employee") return false;
  return (user.metadata as Record<string, unknown>)?.role === "EMPLOYEE";
}

export function shouldEnableRBAC(user: User): boolean {
  const arn = distributorArnFromUsername(user?.username ?? "");

  return Boolean(arn) && !isEmployeeUserWithEmployeeRole(user);
}
